import React, { useEffect, useState } from "react";
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import koisoi from '../../assets/img/koisoi.png';
import midimg1 from '../../assets/img/mid-1.png';
import midimg2 from '../../assets/img/mid-2.png';
import midimg3 from '../../assets/img/mid-3.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faClock, faMobile } from '@fortawesome/free-solid-svg-icons';
import './HomePage.css';

const HomePage = () => {
    const [language, setLanguage] = useState('th');

    const homeData = {
        img: koisoi,
        midimg: [midimg1, midimg2, midimg3],
        location_title: 'ที่ตั้ง',
        location_title_en: 'Location',
        location_title_cn: '地点',
        location: {
            address: 'ถนน เจริญประเทศ ตำบล ช้างม่อย อำเภอเมืองเชียงใหม่ เชียงใหม่ 50100',
            time: 'เปิดทุกวัน 11:00 - 20:00',
            tel: 'โทรศัพท์: 081-234-5678'
        },
        location_en: {
            address: 'Charoen Prathet Road, Chang Moi Subdistrict, Mueang Chiang Mai District, Chiang Mai 50100',
            time: 'Open every day 11:00 - 20:00',
            tel: 'Tel: 081-234-5678'
        },
        location_cn: {
            address: 'Charoen Prathet Road, Chang Moi Subdistrict, Mueang Chiang Mai District, Chiang Mai 50100',
            time: '每天开放 11:00 - 20:00',
            tel: '电话：081-234-5678'
        }
    };

    // Function to get the language from localStorage
    const getLanguageFromLocalStorage = () => {
        const lang = localStorage.getItem('lang');
        if (lang) {
            setLanguage(lang);
        } else {
            localStorage.setItem('lang', 'th');
        }
    };

    useEffect(() => {
        getLanguageFromLocalStorage();
    }, []);

    const getLocalizedData = (data) => {
        switch (language) {
            case 'en':
                return data.location_en;
            case 'cn':
                return data.location_cn;
            default:
                return data.location;
        }
    };

    const localizedData = getLocalizedData(homeData);

    return (
        <>
            <Header />
            <main>
                <div className='container mb-3'>
                    <div className='row mb-3'><div className="col-12"><hr /></div></div>
                    <div className='row'>
                        <div className="col">
                            <img src={homeData.img} className="img-fluid main-fluid" alt="Responsive image" />
                        </div>
                    </div>
                    <div className='row mt-3'>
                        {homeData.midimg.map((img, index) => (
                            <div key={index} className="col-4">
                                <img src={img} className="img-fluid" alt="Responsive image" />
                            </div>
                        ))}
                    </div>
                    <div className='row mt-2'><div className="col-12"><hr /></div></div>
                    <div className='row mt-2'>
                        <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                            <iframe height="300px" src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d4001.0824765167645!2d99.00052808170523!3d18.786201641341705!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sth!4v1719117942708!5m2!1sen!2sth" width="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div className="container contact-box h-100">
                                <div className="row">
                                    <div className="row mt-4 ms-3 address">
                                        <div className="col-">
                                            <h3><FontAwesomeIcon icon={faLocationDot} /> {language === 'th' ? homeData.location_title : language === 'en' ? homeData.location_title_en : homeData.location_title_cn}</h3>
                                            <p>{localizedData.address}</p>
                                        </div>
                                    </div>
                                    <div className="row ms-3 mt-3 address">
                                        <div className="col-">
                                            <h3><FontAwesomeIcon icon={faClock} /> {language === 'th' ? 'เวลาเปิดทำการ' : language === 'en' ? 'Opening Hours' : '营业时间'}</h3>
                                            <p>{localizedData.time}</p>
                                        </div>
                                    </div>
                                    <div className="row ms-3 mt-3 mb-4 address">
                                        <div className="col-">
                                            <h3><FontAwesomeIcon icon={faMobile} /> {language === 'th' ? 'ติดต่อ' : language === 'en' ? 'Contact' : '联系方式'}</h3>
                                            <p>{localizedData.tel}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row '><div className="col-12"><hr /></div></div>
                </div>
            </main>
            <Footer />
        </>
    );
}

export default HomePage;
